<template>
  <div id="alert-dialog">
    <div class="sav-alert-dialog-container">
        <p class="sav-alert-dialog-text">{{ text }}</p>
        <div class="sav-alert-dialog-footer">
            <button @click="closeDialog" class="sav-btn sav-btn-link">ΟΧΙ</button>
            <button @click="submitDialog" class="sav-btn sav-btn-red">ΝΑΙ</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['text', 'visibility', 'submitFunction'],
  methods: {
    closeDialog () {
        this.$parent[this.visibility] = false;
    },
    submitDialog () {
        this.$parent[this.submitFunction]();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

#alert-dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($light-grey, .5);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sav-alert-dialog-container {
    width: 600px;
    padding: 30px 50px;
    background-color: white;
    box-shadow: 0 2px 9px rgba(0,0,0,.25);
    display: flex;
    flex-direction: column;
}

.sav-alert-dialog-text {
    color: $blue;
    font-size: 24px;
    font-weight: 500;
    padding: 0;
    margin: 0 0 40px
}

.sav-alert-dialog-footer {
    display: flex;
    justify-content: flex-end;
    > :not(:last-child) {
        margin-right: 10px;
    }
}
</style>
